export default __webpack_public_path__ + "static/Sven Tang-b6c185449d5e4b4f4f4c88642944fddb.webp";